import { PhoneNumberUtil } from 'google-libphonenumber'

const dictionary = {
  en: {
    messages: { verify_phone: n => 'The field ' + n + ' must be a valid phone number' },
    attributes: { phone: 'phone number' }
  },
  ru: {
    messages: { verify_phone: n => 'Поле ' + n + ' должно быть валидным телефонным номером' },
    attributes: { phone: 'телефонный номер' }
  },
  ja: {
    messages: { verify_phone: n => 'フィールド ' + n + '有効な電話番号でなければなりません' },
    attributes: { phone: '電話番号' }
  }
}

const validator = {
  getMessage: n => 'The field ' + n + ' must be a valid phone number.',
  validate: (val, args) => {
    const phoneUtil = PhoneNumberUtil.getInstance()

    let code = args && args.length > 0 && args[0] ? args[0].code : null
    if (args.code) {
      code = args.code
    }

    let parsed
    try {
      parsed = code ? phoneUtil.parseAndKeepRawInput(val, code) : null
    } catch (e) {
      parsed = null
    }

    return parsed ? phoneUtil.isValidNumber(parsed) : false
  }
}

export default { dictionary, validator }
